var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "bot-table mx-auto" },
    [
      _c(
        "v-card-title",
        [
          _vm._t("bot-table-title"),
          _c("v-spacer"),
          _c("v-text-field", {
            attrs: {
              clearable: "",
              "append-icon": "mdi-magnify",
              label: "Search",
              "single-line": "",
              "hide-details": "",
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        2
      ),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          loading: _vm.spinning,
          headers: _vm.options.headers,
          "show-select": _vm.options["show-select"],
          "single-select": _vm.options["single-select"],
          "item-key": _vm.options["item-key"],
          "items-per-page": _vm.options["items-per-page"],
          items: _vm.dataSource,
          "custom-filter": _vm.botTableFilter,
          search: _vm.search,
        },
        scopedSlots: _vm._u(
          [
            {
              key: `item.data-table-select`,
              fn: function ({ isSelected, select }) {
                return [
                  _c("v-simple-checkbox", {
                    attrs: {
                      value: isSelected,
                      readonly: _vm.spinning,
                      disabled: _vm.spinning,
                    },
                    on: { input: select },
                  }),
                ]
              },
            },
            {
              key: `footer.prepend`,
              fn: function () {
                return [
                  _vm.options["show-select"] && _vm.selected.length
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                title: "Xóa",
                                transition: "fab-transition",
                                "offset-overflow": "",
                                "nudge-width": 200,
                                "offset-x": "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              { attrs: { color: "error" } },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              "\n                            Xóa\n                            "
                                            ),
                                            _c(
                                              "v-icon",
                                              { attrs: { right: "" } },
                                              [_vm._v(" mdi-close-circle ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                301558816
                              ),
                            },
                            [
                              _c(
                                "v-card",
                                [
                                  _c("v-card-title", [_vm._v("Bạn có chắc?")]),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "success darken-1",
                                            text: "",
                                          },
                                          on: { click: _vm.handleRemoveItem },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [_vm._v(" mdi-check ")]
                                          ),
                                          _vm._v(
                                            "\n                                Confirm\n                            "
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-btn",
                                        { attrs: { color: "pink", text: "" } },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [_vm._v(" mdi-close ")]
                                          ),
                                          _vm._v(
                                            "\n                                Cancel\n                            "
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            _vm._l(_vm.options.headers, function (hd) {
              return {
                key: `item.${hd.value}`,
                fn: function ({ item }) {
                  return [
                    hd.type === `badge`
                      ? _c(
                          "div",
                          { key: hd.key },
                          [
                            _c(
                              "v-badge",
                              {
                                attrs: {
                                  color: item[hd.data.color],
                                  content: item[hd.data.content],
                                  left: hd.props.left,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(item[hd.value]) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    hd.type === `number`
                      ? _c("span", { key: hd.key }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm._f("fmn")(item[hd.value])) +
                              "\n            "
                          ),
                        ])
                      : _vm._e(),
                    hd.type === `link`
                      ? _c("span", { key: hd.key }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: item[hd.value.href],
                                title: item[hd.value.title],
                              },
                            },
                            [_vm._v(_vm._s(item[hd.value.title]))]
                          ),
                        ])
                      : _vm._e(),
                    hd.type === `truncate`
                      ? _c("div", { key: hd.key, staticClass: "truncate" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(item[hd.value]) +
                              "\n            "
                          ),
                        ])
                      : _vm._e(),
                    hd.type === "slot"
                      ? _c(
                          "span",
                          { key: hd.key },
                          [
                            _vm._t(`bot-table-header-${hd.value}`, null, {
                              item: item,
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    hd.type === `delete`
                      ? _c(
                          "v-menu",
                          {
                            key: hd.key,
                            attrs: {
                              transition: "fab-transition",
                              "offset-overflow": "",
                              "nudge-width": 200,
                              "offset-x": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          _vm._b(
                                            { attrs: { color: "red" } },
                                            "v-icon",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            "\n                        mdi-close-circle-outline\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c(
                              "v-card",
                              [
                                _c("v-card-title", [_vm._v("Bạn có chắc?")]),
                                _c(
                                  "v-card-actions",
                                  [
                                    _c("v-spacer"),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "success darken-1",
                                          text: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit("deleteItem", item)
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", { attrs: { left: "" } }, [
                                          _vm._v(" mdi-check "),
                                        ]),
                                        _vm._v(
                                          "\n                            Confirm\n                        "
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-btn",
                                      { attrs: { color: "pink", text: "" } },
                                      [
                                        _c("v-icon", { attrs: { left: "" } }, [
                                          _vm._v(" mdi-close "),
                                        ]),
                                        _vm._v(
                                          "\n                            Cancel\n                        "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    hd.type === undefined
                      ? _c("span", { key: hd.key }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(item[hd.value]) +
                              "\n            "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              }
            }),
          ],
          null,
          true
        ),
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/bot/table/bot.table.vue